<script setup>
import { event, fetchEventFromWordpress } from "@/Mixins/FetchesEventsFromWordpress"
import { computed, onMounted } from 'vue'
import moment from 'moment';

import DashboardStatsAdminCard from '@/Components/Dashboard/DashboardStatsAdminCard'
import CalendarIcon from '@/icons/CalendarIcon'

const props = defineProps({
	eventData: {
		type: Array,
		required: true,
	},
	numActiveMembers: {
		type: Number,
		required: true,
	}
})


onMounted(() => {
	fetchEventFromWordpress(props.eventData.remote_id)
})

const membersAttending = computed(() => {
	return props.eventData.attendees.filter(attendee => attendee.organisation_id)
})

const nonMembersAttending = computed(() => {
	return props.eventData.attendees.filter(attendee => !attendee.organisation_id)
})

</script>

<template>
	<DashboardStatsAdminCard
		:icon=CalendarIcon
		v-if="event"
		:data="eventData.numAttendees"
		caption="Total Attendees"
		:href="route('dashboard.events.index')"
		linkText="View All Upcoming Events"
	>
		<div class="text-center mt-1">
			<h1 class="font-bold leading-4">{{ event.title }}</h1>
			<p class="text-sm">{{ moment(eventData.start_date).format("DD MMM YYYY") }}</p>
			<span class="text-xs bg-Blue text-white px-2 py-1 rounded-xl">{{membersAttending.length}}/{{numActiveMembers}} members attending</span>
			<p class="text-xs py-1">{{nonMembersAttending.length}} non-members attending </p>
		</div>
	</DashboardStatsAdminCard>
</template>